import {
  CLEAR_FORM_LANGUAGE_RESTRICTION,
  FormRestrictionsAction,
  SET_FORM_LANGUAGE_RESTRICTION
} from '../actions/FormRestrictionsActions'

interface FormRestrictionsState {
  allowedLanguages: string[] | null
}

const initialState: FormRestrictionsState = {
  allowedLanguages: null
}

const FormRestrictionsReducer = (
  state: FormRestrictionsState = initialState,
  action: FormRestrictionsAction
): FormRestrictionsState => {
  switch (action.type) {
    case SET_FORM_LANGUAGE_RESTRICTION:
      return { ...state, allowedLanguages: action.data }
    case CLEAR_FORM_LANGUAGE_RESTRICTION:
      return { ...state, allowedLanguages: null }
    default:
      return state
  }
}

export default FormRestrictionsReducer
